import { createReducer } from '@reduxjs/toolkit'

import { FunctionPermission } from '@/model/function-permission'
import { axios } from '@/utils/axios'

import { createAppAsyncThunk } from './utils'

const namespace = 'functionPermission'

export const readAllFunctionPermissions = createAppAsyncThunk(
  `${namespace}/readAllFunctions`,
  async () => (await axios.get<FunctionPermission[]>(
    '/menu/function/all',
  )).data,
)

const initialState: {
  functionPermissions: FunctionPermission[]
} = {
  functionPermissions: [],
}

const reducer = createReducer(initialState, (builder) => {
  builder.addCase(readAllFunctionPermissions.fulfilled, (draft, { payload }) => {
    draft.functionPermissions = payload
  })
})

export default { [namespace]: reducer }
